// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/order-list.scss
// module id = 880
// module chunks = 0